import * as Yup from "yup";
import * as moment from "moment";
import { FORMAT } from "./dateOfBirthValidation";

export function getPostInitialValues(editResponse) {
  let equipment0 = false;
  let equipment1 = false;
  let equipment2 = false;
  if (editResponse?.data?.equipmentRequirements) {
    for (let j = 0; j < editResponse.data.equipmentRequirements.length; j++) {
      if (editResponse.data.equipmentRequirements[j] === "FLAT_BED") {
        equipment0 = true;
      }
      if (editResponse.data.equipmentRequirements[j] === "ENCLOSED_TRAILER") {
        equipment1 = true;
      }
      if (editResponse.data.equipmentRequirements[j] === "STRAIGHT_TRUCK") {
        equipment2 = true;
      }
    }
  }

  let condition0 = false;
  let condition1 = false;
  let condition2 = false;
  let condition3 = false;
  let hardOrSoftWood = "";

  const pd = editResponse?.data?.data?.palletDetails || editResponse?.data?.palletDetails || editResponse?.palletDetails;
  if (pd?.condition) {
    const conds = pd.condition;
    if (conds.includes("RECYCLED")) condition0 = true;
    if (conds.includes("NEW")) {
      condition1 = true;
      const newType = pd.newConditionType;
      if (newType === "HARDWOOD" || newType === "New - Hardwood") {
        hardOrSoftWood = "New - Hardwood";
      } else if (newType === "SOFTWOOD" || newType === "New - Softwood") {
        hardOrSoftWood = "New - Softwood";
      }
    }
    if (conds.includes("COMBO")) condition2 = true;
    if (conds.includes("CORES")) condition3 = true;
  }

  let palletType = pd?.palletType?.toLowerCase();
  if (palletType === "euro" || pd?.palletType === "EUROPALLET") {
    palletType = "euroPallet";
  }

  let requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT);
  let loadDetailsObj = editResponse?.data?.loadDetails;
  if (Array.isArray(loadDetailsObj)) {
    loadDetailsObj = loadDetailsObj[0];
  }
  if (loadDetailsObj?.requestDeliveryDate) {
    const clonedOrderDate = moment(loadDetailsObj.requestDeliveryDate);
    const today = moment().startOf("day");
    const validDate = clonedOrderDate.isAfter(today) ? clonedOrderDate : moment().add(1, "day");
    requestDeliveryDate = validDate.format(FORMAT);
  }

  let appt = loadDetailsObj?.deliveryFromtime || "00:00";
  let apptTo = loadDetailsObj?.deliveryTotime || "23:00";
  let poNumber = loadDetailsObj?.poNumber || "";
  let lots = loadDetailsObj?.quantityDetails?.lots || loadDetailsObj?.lots || "";
  let QuantityLot = loadDetailsObj?.quantityDetails?.quantity || loadDetailsObj?.QuantityLot || 540;

  let maxQty = loadDetailsObj?.quantityDetails?.originalQuantity || loadDetailsObj?.originalQuantity || loadDetailsObj?.quantityDetails?.quantity || loadDetailsObj?.QuantityLot || 540;

  const dataObj = editResponse?.data?.data || editResponse?.data || editResponse;
  const refNo = dataObj?.orderRefNumber || "";

  return {
    material: pd?.material || "WOOD",
    condition0,
    condition1,
    condition2,
    condition3,
    hardOrSoftWood,
    palletType: palletType || "",
    moisture: pd?.moisture || "",
    size: pd?.size || "",
    grade: pd?.grade || "",
    isHeatTreared: pd?.heatTreared !== undefined ? pd?.heatTreared : (pd?.heatTreated !== undefined ? pd?.heatTreated : false),
    poNumber,
    lotsOption: dataObj?.lotType || "MULTIPLE",

    businessName: dataObj?.location?.locationId || "",
    requestDeliveryDate,
    appointment: dataObj?.appointment || "DELIVERY_WINDOW",
    appt,
    apptTo,
    equipment0,
    equipment1,
    equipment2,
    lots,
    QuantityLot,
    quantityMaxValue: maxQty,
    originalQuantity: maxQty,

    length: pd?.length || "",
    width: pd?.width || "",
    height: pd?.height || "",

    addMoreArrList: [
      {
        lots,
        QuantityLot,
        requestDeliveryDate,
        appt,
        apptTo,
        poNumber,
      },
    ],
    comments: dataObj?.remark || "",
    cloneOrder: Boolean(refNo),
    orderId: refNo,
  };
}
const VALIDATION_SCHEMA = () => {
  let schemaAttributes = {
  }
  return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };